import {tns} from 'tiny-slider/src/tiny-slider'

export function initSlideshows() {
	$('[data-slideshow]').once('Slideshows').each(function () {
		const $slideshow = $(this)
		$slideshow.removeClass('js-not-yet')

		const slider = tns({
			autoplay: true,
			container: $slideshow.find('> div').get(0),
			touch: true,
			mouseDrag: true,
			loop: false,
			controls: false,
			center: true,
			nav: true,
			navPosition: 'bottom'
		})

		$slideshow.data('tns', slider)
	})
}